import { render, staticRenderFns } from "./HomeworkDetails.vue?vue&type=template&id=6a32c882"
import script from "./HomeworkDetails.vue?vue&type=script&lang=js"
export * from "./HomeworkDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports